<template>
    <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="margin-top: 20px">
        <el-col :xl="3" :lg="3" :md="19" :sm="19" :xs="19" style="line-height: 28px;text-align: right;margin-right: 10px;" v-if="index==0">条件：</el-col>
        <el-col :xl="3" :lg="3" :md="19" :sm="19" :xs="19" style="line-height: 28px;text-align: right;margin-right: 10px;"  v-if="index!=0">
            <el-select
                    v-model="actionForm.logicalOperator"
                    collapse-tags
                    placeholder="请选择"
                    size="mini"
                    style="padding-bottom: 5px;width: 80%">
                <el-option
                        v-for="item in logicalOperatorList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </el-col>
        <el-col :xl="3" :lg="3" :md="24" :sm="24" :xs="24">
            <el-cascader
                    v-model="actionForm.spaceId"
                    @change="spaceChange"
                    ref="sonSpace"
                    :options="spaceList"
                    change-on-select="true"
                    collapse-tags
                    filterable
                    placeholder="空间"
                    size="mini"
                    style="padding-bottom: 5px; width: 80%">
            </el-cascader>
        </el-col>
        <el-col :xl="3" :lg="3" :md="24" :sm="24" :xs="24">
            <el-select
                    v-model="actionForm.deviceId"
                    collapse-tags
                    @change="deviceChange"
                    ref="sonDevice"
                    placeholder="设备"
                    size="mini"
                    style="padding-bottom: 5px;width: 80%">
                <el-option
                        v-for="item in sonDeviceList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
        </el-col>
        <el-col :xl="3" :lg="3" :md="24" :sm="24" :xs="24">
            <el-select
                    v-model="actionForm.devicePointId"
                    collapse-tags
                    @change="pointChange"
                    placeholder="测点"
                    size="mini"
                    style="padding-bottom: 5px;width: 80%">
                <el-option
                        v-for="item in pointList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
        </el-col>
        <el-col :xl="3" :lg="3" :md="24" :sm="24" :xs="24">
            <el-select
                    v-model="actionForm.valueLogicalOperator"
                    collapse-tags
                    placeholder="逻辑"
                    size="mini"
                    style="padding-bottom: 5px;width: 80%">
                <el-option
                        v-for="item in valueLogicalOperatorList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </el-col>
        <el-col :xl="3" :lg="3" :md="24" :sm="24" :xs="24" >
            <el-input class="inline-input" size="mini" placeholder="数值" style="width: 80%" v-model="actionForm.pointValue"></el-input>
        </el-col>
        <el-col :xl="3" :lg="3" :md="24" :sm="24" :xs="24" >
            <el-select
                    v-model="actionForm.triggerType"
                    collapse-tags
                    placeholder="次数"
                    size="mini"
                    style="padding-bottom: 5px;width: 80%">
                <el-option
                        v-for="item in triggerTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </el-col>
        <el-col :xl="2" :lg="2" :md="24" :sm="24" :xs="24">
                <el-button @touchstart="add" @click="add" size="mini" style="color: #07E6F8" v-if="index==0"> +</el-button>
            <el-button size="mini" style="color: red" @touchstart="deleteList" @click="deleteList"  v-if="index!=0"> -</el-button>
        </el-col>
    </el-col>
</template>

<script>
import {getListBySpaceIdAndStatus} from "@/network/device-info";
import {listByDeviceId, pointNameDistinguish} from "@/network/device-measuring-point";

export default {
  name: "SonScene",
  props: {
    item: {
      type: Object,
      default: Object
    },
    index: {
      type: Number,
      required: true
    },
            deviceLinkageConditions: {
                type: Array,
                default: Array
            },
            spaceList: {
                type: Array,
                default: Array
            }
        },
        data(){
            return {
                deviceType:'',
                actionForm:{
                    logicalOperator:'',
                    spaceId:'',
                    spaceName:'',
                    deviceId:'',
                    gatewaySn:'',
                    deviceName:'',
                    triggerType:'',
                    devicePointId:'',
                    devicePointName:'',
                    valueLogicalOperator:'',
                    pointValue:''
                },
                valueLogicalOperatorList:[
                    {value:0,label:'小于'},
                    {value:1,label:'大于'},
                    {value:2,label:'等于'},
                    {value:3,label:'不等于'},
                    {value:4,label:'大于等于'},
                    {value:5,label:'小于等于'}
                ],
                triggerTypeList:[
                    {value:0,label:'每次'},
                    {value:1,label:'单次'}
                ],
                sonDeviceList:[
                    {value:'',label:'请选择设备'}
                ],
                pointList:[
                    {value:'',label:'可选测点'}
                ],
                logicalOperatorList:[
                    {value:0,label:'并且'},
                    {value:1,label:'或着'}
                ]
            }
        },
        created() {
            this.actionForm=this.item;
            this.getDeviceList(this.actionForm.spaceId);
            this.getPointList(this.actionForm.deviceId);
        },
        watch: {
            actionForm: {
                handler (newV) {
                    this.$emit('uploadData', {index: this.index, data: newV})
                },
                deep: true
            },
            deviceLinkageConditions: {
                handler (newV) {
                    if (newV.length !== 0) {
                        this.actionForm = {...newV[this.index]}
                    }
                },
                deep: true
            }
        },
        methods:{
            pointChange(val){
                this.actionForm.devicePointName=this.pointList.filter(i => i.id == val)[0].name;
                this.actionForm.devicePointId=val;
                this.actionForm.valueLogicalOperator='';
            },
            deviceChange(val){
                if(val){
                    if(val.length>0){
                        this.actionForm.deviceId=val;
                        let device=this.sonDeviceList.filter(i => i.id == val)[0];
                        this.actionForm.deviceName=device.name;
                        this.actionForm.gatewaySn=device.gatewaySn;
                        this.deviceType=device.typeEngName;
                        this.getPointList(this.actionForm.deviceId);
                        this.actionForm.devicePointName='';
                        this.actionForm.devicePointId='';
                        this.actionForm.valueLogicalOperator='';
                        this.pointList=[];
                    }
                }
            },
            spaceChange(val){
                if(val){
                    if(val.length>0){
                        this.actionForm.spaceId=val[val.length-1];
                        this.actionForm.spaceName=this.$refs['sonSpace'].getCheckedNodes()[0].data.label;
                        this.getDeviceList(this.actionForm.spaceId);
                        this.actionForm.deviceId='';
                        this.actionForm.deviceName='';
                        this.actionForm.devicePointName='';
                        this.actionForm.devicePointId='';
                        this.actionForm.valueLogicalOperator='';
                        this.pointList=[];
                    }
                }
            },
            add(){
                this.$emit('add')
            },
            deleteList() {
                this.$emit('deleteIndex', this.index)
            },
            getDeviceList(spaceInfo){
                getListBySpaceIdAndStatus(spaceInfo).then(res => {
                    this.sonDeviceList= res.data;
                    if(this.actionForm.deviceId){
                        let device=this.sonDeviceList.filter(i => i.id == this.actionForm.deviceId)[0];
                        this.deviceType=device.typeEngName;
                    }
                })
            },
            getPointList(deviceId){
                listByDeviceId(deviceId).then(res=>{
                    if (res.data) {
                        this.pointList= pointNameDistinguish(res.data,this.deviceType);
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>
